module.exports = __webpack_public_path__ + "static/media/silvy_pass_shadow_low.5097b5ef.png";